import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  card: {
    borderBottomLeftRadius: '0 !important',
    backgroundColor: 'var(--primary__page__background) !important'
  },
  cardBody: {
    backgroundColor: 'var(--primary__page__background) !important'
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between !important'
  },
  carousel: {
    backgroundColor: 'var(--card-button-carousel__color)',
    display: 'flex',
    padding: '5px 30px 40px 15px',
    '&:after': {
      content: "' '",
      minWidth: '20px'
    }
  },
  mediaContainer: {
    '& ul > li > button:before': {
      fontSize: '36px !important',
      lineHeight: '25.5px !important'
    }
  },
  '@media (max-width: 667px)': {
    cardBody: {
      padding: '10px 16px !important'
    }
  },
  title: {
    fontWeight: '600 !important'
  }
})

export default useStyles
